import { Outlet } from "@tanstack/react-router";
import { Menu } from "lucide-react";
import { useState } from "react";
import { AppFooter } from "@/components/layout/AppFooter";
import { MobileSidebar } from "@/components/layout/MobileSidebar";
import type { PbosRole } from "@/components/layout/nav-items";
import { useVersion } from "@/hooks/use-version";

interface MobileShellLayoutProps {
  role: PbosRole;
}

export function MobileShellLayout({ role }: MobileShellLayoutProps) {
  const { data: versionData } = useVersion();
  const [mobileOpen, setMobileOpen] = useState(false);

  return (
    <div className="flex h-screen overflow-hidden">
      <MobileSidebar
        role={role}
        mobileOpen={mobileOpen}
        onMobileClose={() => setMobileOpen(false)}
      />

      <div className="flex flex-1 flex-col overflow-hidden">
        {/* Mobile header — only visible on small screens to expose the drawer toggle */}
        <header className="flex h-12 shrink-0 items-center gap-3 border-b border-border bg-card px-4 md:hidden">
          <button
            type="button"
            onClick={() => setMobileOpen(true)}
            className="rounded p-1 text-muted-foreground hover:text-foreground"
            aria-label="Open menu"
          >
            <Menu className="h-5 w-5" />
          </button>
          <span className="text-sm font-semibold">Prominent Builders</span>
        </header>

        <main className="flex-1 overflow-y-auto bg-background p-3 md:p-6">
          <Outlet />
        </main>

        <AppFooter version={versionData?.version} />
      </div>
    </div>
  );
}
